export default {
  state: {
    auth: {
      show: false,
      forceShow: false,
      showSignup: false,
      signupSelect: false,
      showCorporate: false,
      action: '',
      signup: {
        step: 1,
        mobile: '',
        countryCode: '',
        email: ''
      }
    }
  },
  mutations: {
    setAuthData (state, data) {
      for (let field in data) {
        state.auth[field] = data[field]
      }
    },
    setAuthSignupData (state, data) {
      for (let field in data) {
        state.auth.signup[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/auth.js